import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import StringRen from "csi/heading/String";
import Locale from "csi/siteDefaultLocale";
import { localStore } from "csi/state/rootStore";
import declare from "dojo/_base/declare";


/** Renderer for SelectSetType "Display Name" (C8FB-2570) */
const SelectSetDisplayNameRenderer = declare(StringRen, {
	// Locale resolver for user-defined localizations
	lr: null,
	// Locale resolver for OOTB centric localizations
	lrBase: null,

	/**
	 * @override
	 * Return the Node Name
	 */
	_getValue(ctx: Context, h: Heading) {
		return ctx.queryResult.getNode().$Name;
	},

	/**
	 * @override
	 * Save locale resolvers when heading is rendered
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: HTMLElement) {
		const editLocale = localStore.editLocale;
		this.lr = Locale.getConfigResolver(editLocale);
		this.lrBase = Locale.getBaseResolver(editLocale);
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Localize the value as a Type or SelectSetSubtpe Resource using the selected locale in the switchboard
	 */
	formatValue(value): string {
		return this.getResourceLocale(value) || this.getTypeLocale(value) || "";
	},

	getResourceLocale(value: string): string {
		const subtypeResource = "SelectSetSubtype_" + value;
		return this.lr.getResourceIfExists(subtypeResource) || this.lrBase.getResourceIfExists(subtypeResource);
	},

	getTypeLocale(value: string): string {
		return this.lr.getTypeName(value) || this.lrBase.getTypeName(value);
	},
});

export = SelectSetDisplayNameRenderer;